import { getUseResource } from '../resource';
import { documentationResources } from '../builders/documentationResources';
import { IProductDetails } from '../../models/ProductDetails';
import { IAwsFileMetadata } from '../../resources/models/IAwsFileMetadata';

export interface IProductDocumentation {
  product: IProductDetails;
  s3Files: IAwsFileMetadata[];
}

export interface IDocumentationListResponse {
  productsDocs: IProductDocumentation[];
}

export const apiDocumentation = {
  useDocumentationList: getUseResource(
    documentationResources.getDocumentation,
    (body): IDocumentationListResponse => body
  ),
};
